import store from '../store'

/**
 * @param {string | string[]} permission permission to check
 * @returns {boolean} `true` if user has permission, otherwise `false`
 */
export function hasUserPermission(permission) {
    const token = store.state.user.token
    let permissionArray = typeof permission === 'string' ? [permission] : permission
    
    if (token) {
        return !!permissionArray.filter(
            one => store.state.user.permissions.some(item => item.name === one)
        ).length
    }
    
    return false
}
